var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaktAnalytics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "graph-increase",
    clipPath: "url(#clip0_3653_674)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8V16H8H10.6667V15.3801V14.7601H8.61993H1.23985V9.97367L6.02023 5.1933L6.79432 4.4192L6.90174 4.52662L9.55859 7.18348L14.2154 2.52662L15.8654 0.876707L15.427 0.438353L14.9887 0L13.7771 1.21156L9.5586 5.43006L7.67343 3.5449L7.40468 3.27614L7.40379 3.27703L7.23179 3.10503L6.79344 2.66667L5.58187 3.87824L1.36337 8.09674L1.23985 8.22026V7.38007V0H0.619926H0V8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 9.54757H8.33333L8.33333 10.3334L8.33333 10.7858H6V9.54757ZM8.33333 12H5V8.33337H9.33333V10.3334H12.6667V12.3334H16V16H11.6667V14H8.33333V12ZM9.33333 11.5476V12V12.7858H11.6667V12.3334V11.5476H9.33333ZM12.6667 14V13.5476H15V14.7858H12.6667V14Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3653_674"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaktAnalytics);
export default __webpack_public_path__ + "static/media/takt_analytics.22d5c18e9f1c5f22daa0ed1e51fe4c4c.svg";
export { ForwardRef as ReactComponent };